var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoothWh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.863,
    height: 22,
    viewBox: "0 0 24.863 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1436 -33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.381,0h-3.16a.481.481,0,0,0-.475.4L20.319,3a.481.481,0,0,1-.474.4H.48a.481.481,0,0,0-.474.559L1.9,15.493a.48.48,0,0,0,.474.4H19.738a.481.481,0,0,0,.475-.4L22.378,2.325a.48.48,0,0,1,.474-.4h1.529a.481.481,0,0,0,.481-.48V.481A.481.481,0,0,0,24.381,0",
    transform: "translate(1436 33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.985,17.577A2.212,2.212,0,1,0,7.2,19.789a2.212,2.212,0,0,0-2.212-2.212",
    transform: "translate(1436 33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.487,17.577A2.212,2.212,0,1,0,19.7,19.789a2.212,2.212,0,0,0-2.212-2.212",
    transform: "translate(1436 33)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoothWh);
export default __webpack_public_path__ + "static/media/booth_wh.c24ed4941344e9393226bfc8a8892e0d.svg";
export { ForwardRef as ReactComponent };